import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { CreateBusinessCustomerRequestDto, CustomerCreationResponseDto } from '@/api/generated';
import { useCustomerCreateMutationOptions } from '@/views/customers/status/useCustomerMutationOptions.util.ts';

type Return = {
  createBusinessCustomer: (
    req: CreateBusinessCustomerRequestDto,
  ) => Promise<CustomerCreationResponseDto>;
  isCreatingBusinessCustomer: boolean;
};

export const useCreateBusinessCustomer = (): Return => {
  const { customersApi } = useApiClient();
  const createOptions = useCustomerCreateMutationOptions();

  const { isPending, mutateAsync } = useMutation<
    CustomerCreationResponseDto,
    AxiosError,
    CreateBusinessCustomerRequestDto
  >({
    ...createOptions,
    mutationFn: async req => {
      const res = await customersApi.createBusinessCustomer(req);

      return res.data;
    },
  });

  return {
    createBusinessCustomer: mutateAsync,
    isCreatingBusinessCustomer: isPending,
  };
};
